import React from 'react';
import {Link} from 'gatsby';
import slack from '../../images/integrations/slack.svg';
import telegram from '../../images/integrations/telegram.svg';
import google from '../../images/integrations/google.svg';
import googleSheets from '../../images/integrations/google-sheets.svg';
// import zapier from "../../images/integrations/zapier.png";
import pabbly from '../../images/integrations/pabbly.png';
import webhook from '../../images/integrations/webhooks.svg';
import api from '../../images/integrations/api-monitoring.png';
import discord from '../../images/integrations/discord.svg';
import zapier from '../../images/integrations/zapier.png';
import konnectzit from '../../images/integrations/KonnectzIt.svg';
import integrately from '../../images/integrations/Integrately.svg';
import integromat from '../../images/integrations/Integromat-blue.svg';
import teams from '../../images/integrations/ms-teams.svg';
import './styles.scss';

const HomePageIntegrations = () => {
  const points = [
    {
      name: 'Telegram',
      logo: telegram,
      linkTo: '/telegrambot',
    },
    {
      name: 'Slack',
      logo: slack,
      linkTo: '/slackbot',
    },
    {
      name: 'Gmail',
      logo: google,
    },
    {
      name: 'Google Sheets',
      logo: googleSheets,
      linkTo: '/google-sheets',
    },
    {
      name: 'Discord',
      logo: discord,
      linkTo: '/discord',
    },
    {
      name: 'Pabbly Connect',
      logo: pabbly,
      linkTo: '/pabbly-connect',
    },
    {
      name: 'Webhook',
      logo: webhook,
      linkTo: '/webhook',
    },
    {
      name: 'API',
      logo: api,
      linkTo: '/api-documentation',
    },
    {
      name: 'Zapier',
      logo: zapier,
      linkTo: '/zapier',
    },
    {
      name: 'KonnectzIT',
      logo: konnectzit,
      linkTo: '/konnectzit',
    },
    // {
    //   name: 'Integromat',
    //   logo: integromat,
    //   linkTo: '/integromat',
    // },
    {
      name: 'Integrately',
      logo: integrately,
      linkTo: '/integrately',
    },
    // {
    //   name: 'MS Teams',
    //   logo: teams,
    //   linkTo: '/microsoft-teams',
    // },
  ];

  return (
    <div id="software-integrations" className="text-center mb-30" style={{width: '100%'}}>
      <h2 className="f_size_26 f_700 t_color3 l_height45 mt_20 mb-20 text-center">Software Integrations</h2>
      <div id="integration-mobile" className="integration-mobile row m-0">
        {points.map(item => {
          return (
            <div key={item.name} className="integration-item">
              <div className="promo_item">
                {item.linkTo ? (
                  <Link to={item.linkTo || ''}>
                    <img src={item.logo} alt={item.name} width={44} height={44} />
                    <p>{item.name}</p>
                  </Link>
                ) : (
                  <>
                    <img src={item.logo} alt={item.name} width={44} height={44} />
                    <p>{item.name}</p>
                  </>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default HomePageIntegrations;
